// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import ReactGA from 'react-ga4';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKd2_BP023GytrqwuC99S-rsTTPfKvOLU",
  authDomain: "fbzrum-cloud.firebaseapp.com",
  projectId: "fbzrum-cloud",
  storageBucket: "fbzrum-cloud.firebasestorage.app",
  messagingSenderId: "359626545839",
  appId: "1:359626545839:web:f0fc60b768065b9292d25a",
  measurementId: "G-W5S5ZH2F3M"
};

// Inicializar o Google Analytics 4
const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const db = getFirestore(app);

// --- INICIALIZAÇÃO DO APP CHECK ---
// ATENÇÃO: self.FIREBASE_APPCHECK_DEBUG_TOKEN é para testes locais. Remova em produção.
// self.FIREBASE_APPCHECK_DEBUG_TOKEN = true; 
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LcxEaYrAAAAAEvZnUMGjPpHFJkLVAtw2I6js2jl'),
  isTokenAutoRefreshEnabled: true
});
// ---------------------------------

export { db };